import { toJsonString } from '@nzyme/utils/toJsonString.js';
import { storageRef } from './storageRef.js';
/**
 * Creates a storage ref with schema validation using schema.
 * This ensures that data read from and written to storage always matches
 * the expected schema, providing type safety and data integrity.
 *
 * @template T The type of value to be stored, inferred from the schema
 * @param options Standard storage ref options
 * @returns A storage ref that validates data against the schema
 */
export function storageRefWithSchema(options) {
    return storageRef({
        ...options,
        serialize: value => toJsonString(value),
        deserialize: value => {
            try {
                const json = JSON.parse(value);
                const result = options.schema['~standard'].validate(json);
                if (result instanceof Promise) {
                    return options.default();
                }
                if (result.issues) {
                    return options.default();
                }
                return result.value;
            }
            catch {
                return options.default();
            }
        },
        default: options.default,
    });
}
//# sourceMappingURL=storageRefWithSchema.js.map